<template>
    <div class="atteConfig clearfix">
        <div class="left">
            <div class="title">规则设置</div>
            <el-menu default-active="2" class="el-menu-vertical-demo">

                <el-menu-item index="2" @click="showholidayfuc(false)">
                    <i class="el-icon-tickets"></i>
                    <span slot="title">考勤规则设置</span>
                </el-menu-item>
                <el-menu-item index="3" @click="showholidayfuc(true)">
                    <i class="el-icon-date"></i>
                    <span slot="title">节假日设置</span>
                </el-menu-item>

            </el-menu>
        </div>
        <div class="right" v-if="!showholiday" style="border:none;">
            *考勤规则
            <el-tooltip placement="bottom-start" effect="light">
                <div slot="content">*考勤规则说明：
                    <br/>1、同一考勤规则只能使用一种类型考勤对象，或按楼栋选择，或按校区年级班级选择，或按学生选择；
                    <br/>2、同一个对象只能适用一种考勤规则，如一个年级只能对应一个考勤规则，若同一个对象设置了多个考勤规则，优先级按个人>校区年级班级>楼栋匹配，后添加的规则覆盖先添加的规则。
                    <br/>3、查询在寝时间及之前进出宿舍记录，若最后一次记录为出宿舍，计作
                    <span style="color:red;">未归</span>；
                    <br/>4、查询晚归时间内的记录，若最后一次记录为进宿舍，计作
                    <span style="color:red;">晚归</span>，最后一次记录为出宿舍，计作
                    <span style="color:red;">未归</span>；
                    <br/>5、查询前日在寝结束时间（如早7点）至次日在寝结束时间（如早7点），期间未有进出宿舍记录且最后一次记录为进宿舍，表明该学生未24小时未出宿舍，当日计作
                    <span style="color:red;">异常</span>；
                    <br/>6、查询在寝时间内，晚归开始时间前，最后一次记录为进宿舍，计作
                    <span style="color:red;">正常</span>。
                </div>
                <img src="../../../static/images/systemConfig/xunwen.png" style="vertical-align: top;" />
            </el-tooltip>
            <hr/>
            <div class="addrules">
                <img src="../../../static/images/systemConfig/add.png" />
                <a @click="addRules">添加规则</a>（还可以添加个{{10-BaseResultListform.BaseResultList.length}}规则,最多10条规则）
                <span style="float:right;">统计报表保存时间
                    <el-select v-model="savetime" placeholder="请选择" @change="changesavemouth">
                        <el-option v-for="item in savetimeoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </span>
            </div>
            <div  v-for="(BaseResult,index) in BaseResultListform.BaseResultList" :key="index" > 
            <el-form :model="BaseResult" label-width="100px" ref="BaseResultListform" >
                <div class="BaseResultList" >
                    <div class="title">
                        <el-button style="width:65px" type="primary" v-if="BaseResultListChangeList[index] ||!BaseResult.ruleId " @click="savethisrule(BaseResult, index)" :disabled="BaseResult.lockStatus==0?true:false">保存</el-button>
                        <span v-else>
                            <span style="display:inline-block;width:15px;height:15px;border-radius:50%;background-color:#999;margin-right:10px;vertical-align:middle"></span>{{BaseResult.ruleName}}
                        </span>

                        <span v-if="BaseResult.lockStatus==1&&BaseResult.ruleId">(使用中)</span>
                        <span v-if="BaseResult.lockStatus==0&&BaseResult.ruleId">(已停用)</span>
                        <a v-if="BaseResult.isDefalut==0" class="deleterule" @click="deleterules(BaseResult,index)"></a>
                        <el-button v-if="BaseResult.lockStatus==1&&BaseResult.ruleId" style="float:right" @click="lockStatuUpdate(BaseResult,0,index)" class="tygz">停用规则</el-button>
                        <el-button v-if="BaseResult.lockStatus==0&&BaseResult.ruleId" style="float:right" @click="lockStatuUpdate(BaseResult,1,index)" class="qygz">启用规则</el-button>

                    </div>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item style="margin-bottom:20px;" label="规则名称" prop="ruleName" :rules="{required: true, message: '请输入规则名称', trigger: 'blur'}">
                                <el-input v-model="BaseResult.ruleName" :disabled="BaseResult.lockStatus==0?true:false"></el-input>
                            </el-form-item>
                            <el-form-item label="在寝时间" required style="margin-bottom:20px;">
                                <el-col :span="10" style="padding:0;">
                                    <el-form-item  prop="checkinStart"  :rules="{required: true, message: '请选择在寝开始时间', trigger: 'change'}" >
                                        <el-time-picker format="HH:mm" style="padding:0;width:140px;" :editable="false" v-model="BaseResult.checkinStart " placeholder="开始时间" :disabled="BaseResult.lockStatus==0?true:false" @change="$refs.BaseResultListform[index].validateField('checkinEnd')">
                                        </el-time-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col v-if="BaseResult.suguanAttenType != 2" :span="3" style="padding:0;">-&nbsp;次日</el-col>
                                 <el-col v-else :span="1" style="padding:0;">-&nbsp;</el-col>
                                <el-col :span="10" style="padding:0;">
                                    <el-form-item prop="checkinEnd" :rules="[
                                        {
                                            required: true,
                                            message: '请选择在寝结束时间',
                                            trigger: 'change'
                                        },
                                        {
                                            typeStr: 'checkinEnd',
                                            validator: checkinValidator
                                        }
                                    ]">
                                        <el-time-picker format="HH:mm" style="padding:0;width:140px;" :editable="false" v-model="BaseResult.checkinEnd" placeholder="结束时间" :disabled="BaseResult.lockStatus==0?true:false">
                                        </el-time-picker>
                                    </el-form-item>
                                </el-col>
                            </el-form-item>

                        </el-col>
                        <el-col :span="12">
                            <el-form-item style="margin-bottom:20px;" label="考勤周期" prop="ruleCycle" :rules="{required: true, message: '请输入考勤周期', trigger: 'change'}">
                                <el-select v-model="BaseResult.ruleCycle" multiple placeholder="请选择" :disabled="BaseResult.lockStatus==0?true:false">
                                    <el-option v-for="item in weekoptions" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="考勤对象">
                                <el-select style="margin-bottom:20px;" v-model="BaseResult.checkinObj" placeholder="请选择考勤对象" @change="changevaluemore(BaseResult,index,BaseResult.checkinObjIdKey)" :disabled="BaseResult.lockStatus==0?true:false">
                                    <el-option v-for="item in checkinObjoptions" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>

                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="考勤类型" style="margin-bottom:20px;" prop="suguanAttenType" >
                                <el-select
										v-model="BaseResult.suguanAttenType"
										placeholder="请选择考勤类型"
										size="small"
										:disabled="BaseResult.lockStatus==0?true:false"
									>
										<el-option
											v-for="item in attendceType"
											:key="item.value"
											:label="item.label"
											:value="item.value"
										></el-option>
								</el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="晚归时间" style="margin-bottom:20px;" prop="lateTime" :rules="{required: true, message: '请输入晚归时间', trigger: 'change'}">
                                <el-time-picker format="HH:mm" :editable="false" v-model="BaseResult.lateTime " placeholder="开始时间" style="width:153px;" :disabled="BaseResult.lockStatus==0?true:false">
                                </el-time-picker>
                                -{{BaseResult.suguanAttenType != 2 ? '次日' : ''}}就寝结束时间（
                                <span style="color:red;">晚归时间请设置成在寝开始时间之后的时间点</span>）
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
								<el-checkbox
									style="font-size: 14px;line-height: 40px;margin-left:100px;margin-right:0"
									:false-label="0"
									:true-label="1"
									v-model="BaseResult.isClockOut"
								></el-checkbox>
								<span style="font-size: 14px;line-height: 40px;">出宿舍不打卡</span>
							</el-col>
                        <el-col :span="24">

                            <ul class="zxry">
                                <li v-for="(key,indexorder) in BaseResult.checkinObjName " v-if="indexorder < 5" :key="indexorder" @click="changevaluemore(BaseResult, index,BaseResult.checkinObjIdKey)">
                                    {{key}}
                                </li>
                                <li v-if="BaseResult.checkinObjName!=null&&BaseResult.checkinObjName.length>5">
                                    <a @click="changevaluemore(BaseResult, index,BaseResult.checkinObjIdKey)">更多...</a>
                                </li>
                            </ul>
                        </el-col>
                    </el-row>

                </div>
            </el-form>
            </div>
        </div>
        <div class="right" v-if="showholiday" :loading="holidayload">
            <div class="operation-panel" style="text-align:center;">
                选择月份:
                <el-date-picker v-model="value4" type="month" placeholder="选择月" @change="changemonth">
                </el-date-picker>
                <el-button @click="saveholiday" style="float:right;">保存</el-button>
            </div>
            <div>
                <ul class="weeks" v-loading="calendarloading">
                    <li v-for="(item,index) in weeks" :key="index">
                        {{item}}
                    </li>
                </ul>
                <ul class="calendar" v-loading="calendarloading">
                    <li v-if="item.iflastmonth" v-for="(item,index) in months" :key="index" class="lastmonth">

                        <!-- <p class="Lunar">{{item.day}}</p> -->
                    </li>
                    <li v-if="!item.iflastmonth" v-for="(item,index) in months" :key="index" @click="changholiday(item)" :class="ifholiday(item)">
                        <p class="month">{{item.month}}</p>
                        <p class="Lunar">{{item.holidayobjectnew?item.holidayobjectnew.remark:''}}</p>
                        <!-- <p class="Lunar">{{item.day}}</p> -->
                    </li>
                </ul>

            </div>
            <div>

            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="添加考勤对象(楼栋)" :visible.sync="loudongdialogVisible" width="774px" height="527px" left>
            <div class="autops">
                <el-row :gutter="20" style="width: 100%;    margin-left: -0px;    margin-right: -10px;">
                    <el-col :span="11" style="width:320px;padding:0;border:1px dashed #cccccc; height: 400px;overflow: auto;">
                        <el-row style="height:40px;line-height:40px;">
                            <div class="search bar6">
                                <input type="text" placeholder="请输入院、校区、楼栋查询" name="cname" v-model="filterhouse">
                                <el-button icon="el-icon-search" @click="filterNodehose">查询</el-button>
                            </div>
                        </el-row>
                        <el-row style="height:40px;line-height:40px;">&nbsp;&nbsp;
                            <img src="../../../static/images/systemConfig/xinzeng.png" style="vertical-align: middle;" />&nbsp;&nbsp;选中目标仅能到楼栋
                        </el-row>
                        <el-tree ref="loudongtree" v-show="loudongdialogVisible" :filter-node-method="filterNodehouseshow" :props="defaultProps" :expand-on-click-node="false" @check="handleCheckChange" show-checkbox :data="treeData" node-key='id' style="width:270px" class="combotree">
                        </el-tree>
                    </el-col>
                    <el-col :span="2" style="width: 80px;text-align:center;">
                        <div>
                            <el-button @click="clearlongdong" style="margin-top: 80px;">清空</el-button>
                        </div>
                    </el-col>
                    <el-col :span="12" style="width:320px;padding:0;border:1px dashed #cccccc; height: 400px;overflow: auto;">
                        <div v-for="(checkednode,index) in checktreedata" :key="index" class="checkednode">{{checkednode.lable}}</div>
                    </el-col>
                    <el-col :span="24" style="padding-top: 20px;text-align:center;">
                        <el-button @click="submitForm" type="primary" class="u-btn">确定</el-button>
                        <el-button @click="loudongdialogVisible=false;" class="u-btn">取消</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
        <!-- 2019-07-09和子贵3.0融合，宿管系统的部门树结构全部由院系-年级-班级改为校区-年级-班级 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="添加考勤对象(校区年级班级)" :visible.sync="classdialogVisible" width="774px" height="527px" left>
            <div class="autops">
                <el-row :gutter="20" style="width: 100%;    margin-left: -0px;    margin-right: -10px;">
                    <el-col :span="11" style="width:320px;padding:0;border:1px dashed #cccccc; height: 400px;overflow: auto;">
                        <el-row style="height:40px;line-height:40px;">
                            <div class="search bar6">
                                <input type="text" placeholder="请输入校区、年级、班级查询" name="cname" v-model="filterClass">
                                <el-button icon="el-icon-search" @click="filterNode">查询</el-button>
                            </div>
                        </el-row>
                        <el-row style="height:40px;line-height:40px;">
                            &nbsp;&nbsp;
                            <img src="../../../static/images/systemConfig/xinzeng.png" style="    vertical-align: middle;" />&nbsp;&nbsp;选中目标可到校区、年级、班级
                        </el-row>
                        <el-tree ref="classtree" v-show="classdialogVisible" :filter-node-method="filterNodeshow" :props="classdefaultProps" :expand-on-click-node="false" @check="classhandleCheckChange" show-checkbox :data="classtreeData" node-key='id' style="width:270px" class="combotree">
                        </el-tree>
                    </el-col>
                    <el-col :span="2" style="width: 80px;text-align:center;">
                        <div>
                            <el-button @click="clearclass" style="margin-top: 80px;">清空</el-button>
                        </div>
                    </el-col>
                    <el-col :span="12" style="width:320px;padding:0;border:1px dashed #cccccc; height: 400px;overflow: auto;">
                        <div v-for="(checkednode,index) in checktreedata" :key="index" class="checkednode">{{checkednode.directorName}}</div>
                    </el-col>
                    <el-col :span="24" style="padding-top: 20px;text-align:center;">
                        <el-button @click="submitFormclass" type="primary" class="u-btn">确定</el-button>
                        <el-button class="u-btn" @click="classdialogVisible=false;">取消</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="添加考勤对象(学生)" :visible.sync="studentdialogVisible" width="995px" height="593px" left>
            <div class="autops">
                <el-row :gutter="20" style="width: 100%;    margin-left: -0px;    margin-right: -10px;">
                    <el-col :span="11" style="width:432px;padding:0;border:1px dashed #cccccc; height: 400px;overflow: hidden;    overflow-y: auto;
">
                        <div style="height:40px;    line-height: 40px;">
                            全部人员
                            <div class="search bar6">
                                <input type="text" placeholder="请输入宿舍、学号、姓名查询" name="cname" v-model="studentkey">
                                <el-button icon="el-icon-search" @click="getStudentByKey">查询</el-button>
                            </div>
                        </div>
                        <el-table border stripe :data="studentData" header-row-class-name="table-header" ref="studentData" fit @selection-change="selectchange">
                            <el-table-column prop="order" label="序号" width="40" type="selection" align="center">
                            </el-table-column>
                            <el-table-column prop="studentName" label="姓名" width="80" align="center">
                            </el-table-column>
                            <el-table-column prop="studentCode" label="学号" width="100" align="center">
                            </el-table-column>
                            <el-table-column prop="houseName" label="楼栋" width="130" align="center">
                            </el-table-column>
                            <el-table-column prop="dormitoryName" label="宿舍" align="center" width="60">
                            </el-table-column>

                        </el-table>

                    </el-col>
                    <el-col :span="2" style="width: 80px;text-align:center;">
                        <div style="margin-top: 80px;">
                            <el-button @click="clearpeople">清空</el-button>
                        </div>
                    </el-col>
                    <el-col :span="12" style="width:432px;padding:0;border:1px dashed #cccccc; height: 400px;overflow: hidden;    overflow-y: auto;">
                        <div style="height:40px;    line-height: 40px;">
                            已选人员
                            <div class="search bar6">
                                <input type="text" placeholder="请输入宿舍、学号、姓名查询" name="cname" v-model="showkey">
                                <el-button type="submit" icon="el-icon-search" @click="searchcheckstudents">查询</el-button>
                            </div>
                        </div>
                        <el-table border stripe :data="showcheckstudents" header-row-class-name="table-header" fit>

                            <el-table-column prop="studentName" label="姓名" align="center">
                            </el-table-column>
                            <el-table-column prop="studentCode" label="学号" align="center">
                            </el-table-column>
                            <el-table-column prop="houseName" label="楼栋" align="center">
                            </el-table-column>
                            <el-table-column prop="dormitoryName" label="宿舍" align="center">
                            </el-table-column>
                            <el-table-column prop="dormitoryName" label="操作" align="center">
                                <template slot-scope="scope">
                                    <a @click="deletecheck(scope.row)">删除</a>
                                </template>
                            </el-table-column>

                        </el-table>
                    </el-col>
                    <el-col :span="24">
                        <div class="pagination-container ">
                            <v-pagination @pageChange="onCurrentChange" :total="total" :isShow="showPagination"></v-pagination>
                        </div>
                        <el-button @click="submitFormstudent" type="primary" class="u-btn">确定</el-button>
                        <el-button class="u-btn" @click="studentdialogVisible=false;">取消</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Api from '@/api';
import basetable from '@/mixins/base-table';
import vRules from '@/config/validate_rules';
import store from '@/stores';
import BatchOccupancysearch from '@/components/BatchOccupancysearch/index.vue'
import {
    session
} from '@/util'
export let attendceType = [{
                label: '晚休考勤',
                value: 1
            }, {
                label: '午休考勤',
                value: 2
            }]
export default {

    mixins: [basetable],
    components: {
        BatchOccupancysearch
    },
    data () {
        let vm = this;
		const checkinValidator = (rule, value, cb) => {
            console.log(value)
			let index = vm.BaseResultListform.BaseResultList.indexOf(
				vm.BaseResultListform.BaseResultList.find(item => item[rule.typeStr] === value)
			);
			if (index > -1) {
				let result = vm.BaseResultListform.BaseResultList[index];
				if (result.suguanAttenType == 2) {
					if (
						result.checkinStart &&
						result.checkinEnd &&
						new Date(result.checkinStart).valueOf() >=
							new Date(result.checkinEnd).valueOf()
					) {
						return cb(new Error("在寝结束时间不能早于于开始时间"));
					}
				}
			}

			cb();
        };
        
        return {
            checkinValidator,
            filterhouse: '',
            filterClass: '',
            studentkey: "",
            showkey: '',
            key: '',
            ruleindex: '',
            classdefaultProps: {
                id: 'relId',
                label: 'directorName',
                isLeaf: 'leaf',
                children: "nextLevels",
            },
            defaultProps: {
                id: "onlyFlag",
                relid: "id",
                label: 'lable',
                isLeaf: 'leaf',
                children: "children"
            },
            classtreeData: [],
            treeData: [],
            studentdialogVisible: false,
            loudongdialogVisible: false,
            classdialogVisible: false,
            checkinObjoptions: [{
                value: '1',
                label: '全部学生',
            }, {
                value: '2',
                label: '楼栋',
            }, {
                value: '3',
                label: '校区年级班级',

            }, {
                value: '4',
                label: '个人',
            }],
            weekoptions: [{
                value: '1',
                label: '周一'
            }, {
                value: '2',
                label: '周二'
            }, {
                value: '3',
                label: '周三'
            }, {
                value: '4',
                label: '周四'
            }, {
                value: '5',
                label: '周五'
            }, {
                value: '6',
                label: '周六'
            }, {
                value: '0',
                label: '周日'
            }],
            savetimeoptions: [{
                value: 1,
                label: '1个月'
            }, {
                value: 2,
                label: '2个月'
            }, {
                value: 3,
                label: '3个月'
            }, {
                value: 6,
                label: '6个月'
            }, {
                value: 12,
                label: '12个月'
            }, {
                value: 24,
                label: '24个月'
            },],
            savetime: 6,
            holidayeditlist: [],
            holidayload: false,
            showholiday: false,
            calendarloading: false,
            value4: '',
            months: [],
            weeks: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
            year: '',
            month: '',
            BaseResultListform: {
                BaseResultList: []
            },
            checktreedata: [],
            studentData: [],
            checkstudents: [],
            showcheckstudents: [],
            filtershowcheckstudents: [],
            objects: [],
            doNotInit: true,
            isMounted: false,
            BaseResultListChangeList: [],
            rules: {
                checkinEnd: [
					{
						required: true,
						message: "请选择在寝结束时间",
						trigger: "change"
					},
					{
						typeStr: "checkinEnd",
						validator: checkinValidator
						// 	trigger: "change"
					}
				],
            },
            attendceType
        }
    },

    computed: {

    },
    methods: {
        filterNodehouseshow (value, data) {

            if (!value) return true;
            if (data.lable.indexOf(value) !== -1) {

                this.$refs.loudongtree.getCurrentNode(data);
                return data.lable.indexOf(value) !== -1;
            }

        },
        filterNodehose () {
            this.$refs.loudongtree.filter(this.filterhouse);
        },
        filterNodeshow (value, data) {



            if (!value) return true;
            if (data.treePath.indexOf(value) !== -1) {

                this.$refs.classtree.getCurrentNode(data);
                return data.treePath.indexOf(value) !== -1;
            }

        },
        filterNode () {
            this.$refs.classtree.filter(this.filterClass);
        },
        clearlongdong () {
            this.checktreedata = [];
            this.$refs.loudongtree.setCheckedKeys([]);
        },
        clearclass () {
            this.checktreedata = [];
            this.$refs.classtree.setCheckedKeys([]);
        },
        clearpeople () {
            this.filtershowcheckstudents = [];

            this.showcheckstudents = this.filtershowcheckstudents.filter(x => x.dormitoryName.indexOf(this.showkey) >= 0 || x.studentName.indexOf(this.showkey) >= 0 || x.studentCode.indexOf(this.showkey) >= 0);

        },
        searchSystemConfig () {
            let user = session('user');
            Api.systemConfig.getReportSavingBySchoolId(user.schoolId).then(res => {
                if (res.code == 0) {
                    if (res.data) {
                        this.savetime = res.data.monthDefault;
                        session("savemouth", this.savetime);
                    }

                }
            })
        },
        changesavemouth (val) {

            session("savemouth", val);
        },
        deletecheck (row) {
            this.filtershowcheckstudents.splice(this.showcheckstudents.findIndex(item => item.id === row.id), 1)

            this.showcheckstudents = this.filtershowcheckstudents.filter(x => x.dormitoryName.indexOf(this.showkey) >= 0 || x.studentName.indexOf(this.showkey) >= 0 || x.studentCode.indexOf(this.showkey) >= 0);

        },
        searchcheckstudents () {

            this.showcheckstudents = this.filtershowcheckstudents.filter(x => x.dormitoryName.indexOf(this.showkey) >= 0 || x.studentName.indexOf(this.showkey) >= 0 || x.studentCode.indexOf(this.showkey) >= 0);
        },
        // clearpeople() {

        // 	this.studentData = session('allstudentData');
        // 	this.$refs.studentData.clearSelection();

        // 	this.checkstudents = [];
        // },
        selectchange (selection, row) {

            let selectionlist = Object.assign([], selection);
            if (this.filtershowcheckstudents) {
                this.filtershowcheckstudents = selectionlist.concat(this.filtershowcheckstudents);
                this.filtershowcheckstudents = this.dedupe(this.filtershowcheckstudents);
                this.showcheckstudents = this.filtershowcheckstudents.filter(x => x.dormitoryName.indexOf(this.showkey) >= 0 || x.studentName.indexOf(this.showkey) >= 0 || x.studentCode.indexOf(this.showkey) >= 0);

            } else {
                this.filtershowcheckstudents = selectionlist;
                this.showcheckstudents = this.filtershowcheckstudents.filter(x => x.dormitoryName.indexOf(this.showkey) >= 0 || x.studentName.indexOf(this.showkey) >= 0 || x.studentCode.indexOf(this.showkey) >= 0);

            }
        },

        dedupe (oldArr) {
            var allArr = [];
            for (var i = 0; i < oldArr.length; i++) {
                var flag = true;
                for (var j = 0; j < allArr.length; j++) {
                    if (oldArr[i].id == allArr[j].id) {
                        flag = false;
                    };
                };
                if (flag) {
                    allArr.push(oldArr[i]);
                };
            };
            return allArr;

        },
        addRules () {
            let user = session('user');
            let BaseResult = {
                checkinEnd: "",
                checkinObj: "1",
                checkinObjId: "",
                checkinObjName: "",
                checkinObjNamelist: [],
                checkinStart: "",
                createTime: "",
                createUser: '',
                isDefalut: 0,
                lateTime: "",
                lockStatus: 1,
                remark: "",
                ruleCycle: "",
                ruleId: '',
                ruleName: "",
                schoolId: user.schoolId,
                schoolNum: 0,
                status: "1",
                updateTime: "",
                updateUser: 0,
                suguanAttenType: 1
            }
            if (this.BaseResultListform.BaseResultList.length < 10) {
                this.BaseResultListform.BaseResultList.unshift(BaseResult);
            }

        },
        savethisrule (obj, index) {
            this.$refs['BaseResultListform'][index].validate(valid => {
                if (valid) {
                    let item = Object.assign({}, obj);
                    item.ruleCycle = item.ruleCycle ? item.ruleCycle.join(',') : "";
                    item.checkinStart = this.formatDate(item.checkinStart, 'HH:mm')
                    item.checkinEnd = this.formatDate(item.checkinEnd, 'HH:mm')
                    item.lateTime = this.formatDate(item.lateTime, 'HH:mm')
                    item.checkinObjId = item.checkinObjId ? item.checkinObjId.join(',') : "";
                    item.checkinObjName = item.checkinObjName ? item.checkinObjName.join(',') : "";
                    item.checkinObjIdKey = item.checkinObjIdKey ? item.checkinObjIdKey.join(',') : "";
                    if (item.checkinObj != 1) {
                        if (!item.checkinObjId) {
                            this.$message("请选择考勤对象");
                            return false;
                        }
                    }
                    if (item.ruleId) {
                        Api.systemConfig.updateCheckInRule(item).then(res => {
                            if (res.code == 0) {
                                this.$set(this.BaseResultListChangeList, index, false);
                                this.$message(res.message);

                            } else {
                                this.$message(res.message);
                            }
                        })
                    } else {
                        Api.systemConfig.addCheckInRule(item).then(res => {
                            if (res.code == 0) {
                                obj.ruleId = res.data;
                                this.$set(obj, 'change', false);
                                this.$message(res.message);
                            } else {
                                this.$message(res.message);
                            }
                        })
                    }
                }
            });
        },
        submitForm () {

            var checkinObjId = '';
            var checkinObjName = '';
            var checkinObjIdKey = '';
            for (let index = 0; index < this.checktreedata.length; index++) {
                const element = this.checktreedata[index];

                if (index == 0) {
                    checkinObjId += element.id;
                    checkinObjIdKey += element.onlyFlag;
                    checkinObjName += element.lable;
                } else {
                    checkinObjId += ',' + element.id;
                    checkinObjIdKey += ',' + element.onlyFlag;
                    checkinObjName += ',' + element.lable;
                }
            }
            this.BaseResultListform.BaseResultList[this.ruleindex].checkinObjId = checkinObjId.split(",");
            this.BaseResultListform.BaseResultList[this.ruleindex].checkinObjIdKey = checkinObjIdKey.split(",");
            this.BaseResultListform.BaseResultList[this.ruleindex].checkinObjName = checkinObjName.split(",");

            this.loudongdialogVisible = false;
        },
        submitFormstudent () {
            var checkinObjId = '';
            var checkinObjName = '';
            var checkinObjIdKey = '';
            for (let index = 0; index < this.filtershowcheckstudents.length; index++) {
                const element = this.filtershowcheckstudents[index];
                if (index == 0) {
                    checkinObjId += element.id;
                    checkinObjName += element.studentName;
                    checkinObjIdKey += element.id;
                } else {
                    checkinObjId += ',' + element.id;
                    checkinObjName += ',' + element.studentName;
                    checkinObjIdKey += ',' + element.id;
                }
            }
            this.BaseResultListform.BaseResultList[this.ruleindex].checkinObjId = checkinObjId.split(",");
            this.BaseResultListform.BaseResultList[this.ruleindex].checkinObjName = checkinObjName.split(",");
            this.BaseResultListform.BaseResultList[this.ruleindex].checkinObjIdKey = checkinObjIdKey.split(",");
            this.studentdialogVisible = false;
        },
        submitFormclass () {
            var checkinObjId = '';
            var checkinObjName = '';
            var checkinObjIdKey = '';
            for (let index = 0; index < this.checktreedata.length; index++) {
                const element = this.checktreedata[index];

                if (index == 0) {
                    checkinObjId += element.relId;
                    checkinObjName += element.directorName;
                    checkinObjIdKey += element.id;
                } else {
                    checkinObjId += ',' + element.relId;
                    checkinObjName += ',' + element.directorName;
                    checkinObjIdKey += ',' + element.id;
                }
            }
            this.BaseResultListform.BaseResultList[this.ruleindex].checkinObjId = checkinObjId.split(",");
            this.BaseResultListform.BaseResultList[this.ruleindex].checkinObjIdKey = checkinObjIdKey.split(",");
            this.BaseResultListform.BaseResultList[this.ruleindex].checkinObjName = checkinObjName.split(",");
            this.classdialogVisible = false;
        },
        classhandleCheckChange () {
            let user =store.getters.user;
            this.checktreedata = this.$refs.classtree.getCheckedNodes();
            // let level=user.style=='1'?2:4;
            //  2019-07-09和子贵3.0融合，宿管系统的部门树结构全部由院系-年级-班级改为校区-年级-班级, type为5为班级
            let type = 5;
            this.checktreedata = this.checktreedata.filter(res => res.type == type);
        },
        handleCheckChange () {
            this.checktreedata = this.$refs.loudongtree.getCheckedNodes();
            this.checktreedata = this.checktreedata.filter(res => res.leavel == 2);

        },
        lockStatuUpdate (item, status, index) {
            let statuslabel = status == 1 ? '启用' : '停用'
            this.$confirm('确定' + statuslabel + '这个规则?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(_ => {
                Api.systemConfig.lockStatuUpdate(item.ruleId, status).then(res => {
                    this.BaseResultListform.BaseResultList[index].lockStatus = status;
                })
            })
                .catch(_ => { });
        },
        deleterules (item, index) {
            if (item.ruleId) {
                this.$confirm('确定删除这个规则?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(_ => {
                    Api.systemConfig.deleteCheckInRule(item.ruleId).then(res => {
                        this.BaseResultListform.BaseResultList.splice(index, 1);
                    })
                })
                    .catch(_ => { });
            } else {
                this.BaseResultListform.BaseResultList.splice(index, 1);
            }

        },
        changevaluemore (val, index, objects) {
            let user =store.getters.user;

            switch (val.checkinObj) {
                case '1':
                    this.BaseResultListform.BaseResultList[index].checkinObjId = null;
                    this.BaseResultListform.BaseResultList[index].checkinObjName = null;
                    this.BaseResultListform.BaseResultList[index].checkinObjIdKey = null;
                    break;
                case '2':
                    Api.systemConfig.querySchoolHouseTree(user.schoolId).then(res => {
                        this.treeData = res.data.treeDTOList;
                        this.loudongdialogVisible = true;
                        this.ruleindex = index;
                        this.checktreedata = [];

                        if (objects) {
                            this.$nextTick(() => {
                                this.$refs.loudongtree.setCheckedKeys(val.checkinObjId);
                                this.checktreedata = this.$refs.loudongtree.getCheckedNodes();
                                this.checktreedata = this.checktreedata.filter(res => res.leavel == 2);
                            })
                        }
                    })
                    break;
                case '3':
                    Api.common.querySchoolRelationTree(user.schoolId).then(res => {
                        // let treedata = [];
                        // treedata.push(res.data)
                        this.classtreeData = res.data;
                        this.classdialogVisible = true;
                        this.ruleindex = index;
                        this.checktreedata = [];
                        if (objects) {
                            this.$nextTick(() => {

                                this.$refs.classtree.setCheckedKeys(objects);
                                this.checktreedata = this.$refs.classtree.getCheckedNodes();
                                // let level=user.style=='1'?2:4;
                                let type= '5';
                                this.checktreedata = this.checktreedata.filter(res => res.type == type);
                            })
                        }

                    })
                    break;
                case '4':

                    this.studentkey = '';
                    this.showkey = '';
                    this.getStudentByKey();
                    if (objects) {

                        this.getStudentListByIds(objects.join(','));
                    } else {
                        this.filtershowcheckstudents = [];
                        this.showcheckstudents = [];

                    }
                    //
                    // Api.systemConfig.getStudentByKey(strkey, this.page, this.size).then(res => {

                    // 	this.checkstudents = [];
                    // 	this.showcheckstudents = [];
                    // 	let allstudentData = Object.assign([], res.data.list);
                    // 	this.objects=objects;
                    // 	this.studentdialogVisible = true;
                    // 	this.$nextTick(() => {
                    // 		if(objects)
                    // 		{
                    // 			this.studentData = allstudentData.filter(x => this.objects.indexOf(x.id + "") === -1);
                    // 			this.filtershowcheckstudents = allstudentData.filter(x => objects.indexOf(x.id + "") >= 0);
                    // 	    	this.showcheckstudents=this.filtershowcheckstudents.filter(x =>x.dormitoryName.indexOf(this.showkey)>=0||x.studentName.indexOf(this.showkey)>=0);

                    // 		}else
                    // 		{
                    // 			  this.studentData = allstudentData;
                    // 			  this.filtershowcheckstudents = [];
                    // 	    	  this.showcheckstudents=this.filtershowcheckstudents.filter(x =>x.dormitoryName.indexOf(this.showkey)>=0||x.studentName.indexOf(this.showkey)>=0||x.studentName.indexOf(this.showkey)>=0);
                    // 		}
                    // 	});

                    // })
                    this.ruleindex = index;
                    break;
                default:
                    break;
            }
        },
        getStudentByKey () {
            this.onCurrentChange(1);
            this.loadData();
        },
        getStudentListByIds (ids) {
            Api.systemConfig.getStudentListByIds(ids).then(res => {
                this.filtershowcheckstudents = res.data.map(item => {
                    // id命名统一，保存时方便取值。
                    item.id = item.id || item.student_id;
                    return item
                });
                this.showcheckstudents = this.filtershowcheckstudents.filter(x => x.dormitoryName.indexOf(this.showkey) >= 0 || x.studentName.indexOf(this.showkey) >= 0 || x.studentCode.indexOf(this.showkey) >= 0);

            });
        },
        loadData () {
            let strkey = '';
            if (this.studentkey) {
                strkey = 'key=' + this.studentkey;
            }
            Api.systemConfig.getStudentByKey(strkey, this.page, this.size).then(res => {
                this.checkstudents = [];
                let allstudentData = Object.assign([], res.data.list);
                this.studentdialogVisible = true;
                this.$nextTick(() => {
                    this.studentData = allstudentData;
                    this.total = res.data.total;
                });
            });
        },
        changevalue (val, index) {
            let user = session('user');
            switch (val.checkinObj) {
                case '1':
                    this.BaseResultListform.BaseResultList[index].checkinObjId = null;
                    this.BaseResultListform.BaseResultList[index].checkinObjName = null;
                    this.BaseResultListform.BaseResultList[index].checkinObjIdKey = null;
                    break;
                case '2':
                    Api.systemConfig.querySchoolHouseTree(user.schoolId).then(res => {
                        this.treeData = res.data.treeDTOList;
                        this.loudongdialogVisible = true;
                        this.ruleindex = index;
                        this.checktreedata = [];

                    })
                    break;
                case '3':
                    Api.common.querySchoolRelationTree(user.schoolId).then(res => {
                        let treedata = [];
                        treedata.push(res.data)
                        this.classtreeData = treedata;
                        this.classdialogVisible = true;
                        this.ruleindex = index;
                        this.checktreedata = [];
                    })
                    break;
                case '4':
                    let strkey = '';
                    if (this.studentkey) {
                        strkey = 'key=' + this.studentkey;
                    }
                    Api.systemConfig.getStudentByKey(strkey, this.page, 999999).then(res => {
                        this.studentdialogVisible = true;
                        this.checkstudents = [];
                        this.showcheckstudents = [];
                        this.filtershowcheckstudents = [];
                        this.studentData = res.data.list;
                        this.ruleindex = index;
                    })
                    break;
                default:
                    break;
            }
        },
        showholidayfuc (ifshow) {
            if (ifshow) {
                var date = new Date(); //获取一个时间对象
                this.year = date.getFullYear();
                this.month = date.getMonth() + 1;
                let letmonth = this.month < 10 ? '0' + this.month : this.month;
                this.value4 = this.year + '-' + letmonth;
                this.getholiday(this.year, this.month);
                this.showholiday = true;
            } else {
                this.getCheckInRuleBySchoolId();
                this.showholiday = false;
            }
        },
        getCheckInRuleBySchoolId () {
            let user = session('user');
            var date = new Date(); //获取一个时间对象
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let data = date.getDate(); //获取当前日(1-31)
            Api.systemConfig.getCheckInRuleBySchoolId(user.schoolId).then(res => {
                res.data.forEach(item => {
                    let checkinStart = item.checkinStart.split(':');
                    let checkinEnd = item.checkinEnd.split(':');
                    let lateTime = item.lateTime.split(':');
                    item.checkinStart = new Date(year, month, data, checkinStart[0], checkinStart[1]),
                        item.checkinEnd = new Date(year, month, data, checkinEnd[0], checkinEnd[1]),
                        item.lateTime = new Date(year, month, data, lateTime[0], lateTime[1]),
                        item.ruleCycle = item.ruleCycle.split(',');
                    item.checkinObjId = item.checkinObjId ? item.checkinObjId.split(',') : null;
                    item.checkinObjName = item.checkinObjName ? item.checkinObjName.split(',') : null;
                    item.checkinObjIdKey = item.checkinObjIdKey ? item.checkinObjIdKey.split(',') : null;
					item.isClockOut = item.isClockOut || 0;
                })
                this.BaseResultListform.BaseResultList = res.data;

                if (this.BaseResultListform.BaseResultList && this.BaseResultListform.BaseResultList.length > 0) {
                    // 监听数值改变时显示保存按钮
                    this.BaseResultListform.BaseResultList.forEach((form, index) => {

                        this.$watch(()=> {
                            return form
                        },()=> {
                            this.$set(this.BaseResultListChangeList, index , true);
                        },{
                            deep: true
                        })
                    })
                }
            })
        },
        changemonth (val) {
            this.year = val.getFullYear();
            this.month = val.getMonth() + 1;
            let letmonth = this.month < 10 ? '0' + this.month : this.month;
            this.value4 = this.year + '-' + letmonth;
            this.getholiday(this.year, this.month);
        },
        ifholiday (item) {
            let classname = '';
            if (item.holidayobjectnew) {
                classname = item.holidayobjectnew.status == 1 ? 'holiday' : item.holidayobjectnew.status == 2 ? 'paiban' : '';
            } else {
                classname = '';
            }
            return classname;
        },
        changholiday (item) {
            if (item.holidayobjectnew) {
                if (item.holidayobjectnew.status == 1) {
                    item.holidayobjectnew.status = 3;
                } else if (item.holidayobjectnew.status == 2) {
                    item.holidayobjectnew.status = 1;
                    if (!item.holidayobjectold) {
                        item.holidayobjectnew = null;
                    }
                } else if (item.holidayobjectnew.status == 3) {
                    item.holidayobjectnew.status = 1;
                }
            } else {
                let elementmonth = {
                    createDate: "",
                    dayType: "",
                    holidayDate: item.holidayDate,
                    holidayYearMonth: item.holidayYearMonth,
                    id: "",
                    operateId: null,
                    remark: null,
                    schoolId: null,
                    status: 1,
                    updateDate: null,
                }
                item.holidayobjectnew = elementmonth;
            }
        },
        getDaysInMonth (year, month) {
            month = parseInt(month, 10); //parseInt(number,type)这个函数后面如果不跟第2个参数来表示进制的话，默认是10进制。
            var temp = new Date(year, month, 0);
            return temp.getDate();

        },
        saveholiday () {
            this.holidayeditlist = [];
            let newlist = this.months.filter(x => x.holidayobjectnew != null)
            for (let index = 0; index < newlist.length; index++) {
                const element = newlist[index];
                if (element.holidayobjectold == null) {

                    this.holidayeditlist.push(element.holidayobjectnew);
                } else if (element.holidayobjectold.status != element.holidayobjectnew.status) {
                    this.holidayeditlist.push(element.holidayobjectnew);
                }
            }
            Api.systemConfig.setHoliday(
                this.holidayeditlist
            ).then(res => {
                if (res.code == 0) {
                    this.$message(res.message);
                } else {
                    this.$message(res.message);
                }
            })

        },
        getholiday (year, month) {
            let user = session('user');
            this.holidayload = true;
            let monthday = this.getDaysInMonth(year, month); //获取本月天数
            let prevmonth = month == 1 ? 12 : month - 1;
            let prevmonthday = this.getDaysInMonth(year, prevmonth); //获取上月月天数
            month = month < 10 ? '0' + month : month;
            var dateStr = year + '-' + month + '-01';
            var myDate = new Date(Date.parse(dateStr.replace(/-/g, "/")));
            let week = myDate.getDay();
            this.months = [];
            for (let index = prevmonthday - week + 1; index <= prevmonthday; index++) {
                let element = index;
                element = element < 10 ? '0' + element : element;
                let elementmonth = {
                    month: element,
                    Lunar: "",
                    holidayYearMonth: year + '-' + month,
                    holidayDate: year + '-' + prevmonth + '-' + element + ' 00:00:00',
                    holidayobjectold: null,
                    holidayobjectnew: null,
                    iflastmonth: true
                }
                this.months.push(elementmonth);
            }
            for (let index = 1; index <= monthday; index++) {
                let element = index;
                element = element < 10 ? '0' + element : element;
                let elementmonth = {
                    month: element,
                    Lunar: "",
                    holidayYearMonth: year + '-' + month,
                    holidayDate: year + '-' + month + '-' + element + ' 00:00:00',
                    holidayobjectold: null,
                    holidayobjectnew: null,
                    iflastmonth: false
                }
                this.months.push(elementmonth);
            }
            Api.systemConfig.getHolidaysByMonth(year + '-' + month, user.schoolId).then((res) => {
                let HolidaysByMonths = res.data;
                if (HolidaysByMonths) {
                    for (let index = 0; index < HolidaysByMonths.length; index++) {
                        const element = HolidaysByMonths[index];
                        for (let j = 0; j < this.months.length; j++) {
                            const month = this.months[j];
                            if (month.holidayDate == element.holidayDate) {
                                month.holidayobjectold = Object.assign({}, element);
                                month.holidayobjectnew = Object.assign({}, element);
                            }
                        }
                    }
                }
                this.holidayload = false;
            })
        }
    },
    created () {

    },
    mounted () {
        session("savemouth", this.savetime);
        this.showholidayfuc(false);
        this.searchSystemConfig();

    }
}
</script>
<style lang="scss" scoped>
.atteConfig {
  width: 1200px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  .left {
    width: 200px;
    height: 400px;
    float: left;
    .title {
      width: 100%;
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      color: #fff;
      background-color: #26aef3;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    .el-menu {
      background: #fff;
    }
  }
  .right {
    width: 960px;
    margin: 0 20px;
    float: left;
    border: 1px solid #dbdbdb;
    .BaseResultList {
      border: 1px solid #cccccc;
      background: #fafafa;
      min-height: 240px;
      margin-bottom: 20px;
      padding: 20px;
      .title {
          line-height: 40px;
        .deleterule {
          width: 20px;
          height: 20px;
          display: block;
          background: url(../../../static/images/systemConfig/delete.png)
            no-repeat;
          float: right;
          margin-left: 10px;
        }
        .deleterule:hover {
          background: url(../../../static/images/systemConfig/deleteblue.png)
            no-repeat;
        }
      }
    }
    .addrules {
      height: 58px;
      line-height: 58px;
      font-size: 12px;
    }
    .operation-panel {
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
      background-color: #f0f0f0;
    }
    .weeks {
      margin: auto;
      height: 35px;
      margin-bottom: 0px;
      li {
        float: left;
        width: 126px;
        height: 35px;
        margin: 10px 10px 0 0;
        padding: 5px;
      }
    }
    .zxry {
      li {
        list-style: none;
        float: left;
        border: none;
        background: #26aef3;
        color: white;
        padding: 6px;
        font-size: 12px;
        margin-left: 10px;
        margin-bottom: 10px;
        cursor: pointer;
      }
    }
    .calendar {
      margin: auto;
      height: 520px;
      margin-bottom: 140px;
      li {
        float: left;
        width: 126px;
        height: 95px;
        margin: 10px 10px 0 0;
        background: #f7f7f7;
        padding: 5px;
        p.month {
          margin: 0;
          padding: 5px 0 5px 0;
          font-size: 18px;
        }
        p.Lunar {
          margin: 0;
          padding: 0;
          font-size: 12px;
          color: #74accf;
        }
      }
      li.holiday {
        background: #d8e9ff url(../../../static/images/systemConfig/holiday.png)
          no-repeat right bottom;
      }
      li.paiban {
        background: #d8e9ff url(../../../static/images/systemConfig/course.png)
          no-repeat right bottom;
      }
      li.lastmonth {
        background: #fff;
      }
    }
  }
}

.checkednode {
  padding: 5px;
}

.tygz {
  background: #ffb325;
  color: white;
}

.qygz {
  background: #2babf6;
  color: white;
}

.search {
  width: 270px;
  position: relative;
  height: 28px;
  line-height: 28px;
  margin-top: 10px;
  margin-left: 15px;
  input {
    width: 100%;
    border: 1px solid #c0c4cc;
    border-radius: 5px;
    background: transparent;
    top: 0;
    right: 0;
    height: 28px;
    line-height: 28px;
    outline: none;
    padding: 5px;
  }
  button {
    position: absolute;
    padding: 0;
    border: 1px solid #c0c4cc;
    border-radius: 0 5px 5px 0;
    width: 60px;
    top: 0;
    right: 0;
    height: 28px;
    line-height: 28px;
    outline: none;
    color: #333333;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/systemConfig/attendanceRuleConfig.vue